import { type ReactNode } from "react"

import { useAuthorized } from "@/hooks/use-authorized"

type AuthorizedParams = Parameters<typeof useAuthorized>[0]

type Props = {
  fallback?: ReactNode
  children: ReactNode
} & AuthorizedParams

export function Authorized({ permissions, ifAll, children, fallback }: Props) {
  const isAuthorized = useAuthorized({ permissions, ifAll })

  if (isAuthorized) {
    return <>{children}</>
  }

  if (fallback) return <>{fallback}</>

  return null
}
